import { ref } from 'vue';

const contactData = ref();
const loadingContactData = ref(true);
const personId = ref();
const showCard = ref();
const showPhoneCard = ref(false);
const showEmailCard = ref(false);

export default function () {
  return {
    contactData,
    loadingContactData,
    personId,
    showEmailCard,
    showPhoneCard,
    showCard,
  };
}
